import {
  GIFT_LID_POSITION_PRESETS,
  normalizeGiftLidLayout,
  normalizeGiftLidTextColor,
} from "../components/GiftBoxLidEditor";

function positionIdFromLabel(label) {
  const needle = String(label || "").trim().toLowerCase();
  const found = GIFT_LID_POSITION_PRESETS.find(
    (preset) => preset.label.toLowerCase() === needle,
  );
  return found?.id || "center";
}

/**
 * Parse one segment from the Orders sheet Items cell.
 * Format: `Name (ID: HOM001) × 2 @ ₹150 — Gift box: … [Gift box position: …] [Gift box text: …]`
 */
export function parseOrderGiftItemSegment(segment) {
  const raw = String(segment || "").trim();
  if (!raw) return null;

  const headMatch = raw.match(/^(.+?)\s*\(ID:\s*([^)]+)\)\s*×\s*(\d+)/i);
  if (!headMatch) {
    return { raw, name: raw, id: "", quantity: 1 };
  }

  const name = headMatch[1].trim();
  const id = headMatch[2].trim();
  const quantity = Math.max(1, Number.parseInt(headMatch[3], 10) || 1);

  let giftLidMessage = "";
  const giftSplit = raw.split(/—\s*Gift box:\s*/i);
  if (giftSplit.length > 1) {
    giftLidMessage = giftSplit[1].split(/\s*\[Gift box /i)[0].trim();
  }

  let giftLidLayout = null;
  const layoutMatch = raw.match(/\[Gift box position:\s*([^,]+),\s*([\d.]+)×\]/i);
  if (layoutMatch) {
    giftLidLayout = normalizeGiftLidLayout({
      position: positionIdFromLabel(layoutMatch[1]),
      scale: Number.parseFloat(layoutMatch[2]),
    });
  }

  let giftLidTextColor = null;
  const colorMatch = raw.match(/\[Gift box text:\s*(gold|silver)\]/i);
  if (colorMatch) {
    giftLidTextColor = normalizeGiftLidTextColor(colorMatch[1]);
  }

  return {
    raw,
    name,
    id,
    quantity,
    giftLidMessage,
    giftLidLayout,
    giftLidTextColor,
  };
}

/** All line items from an order Items cell. */
export function parseOrderGiftItems(itemsText) {
  return String(itemsText || "")
    .split(/\s*\|\s*/)
    .map((part) => parseOrderGiftItemSegment(part))
    .filter(Boolean);
}

/** Customisation / shop image for admin gift-box preview. */
export function productLidPreviewUrls(product) {
  if (!product) return [];
  const custom = product.customisationImages || [];
  if (custom.length) return custom;
  return product.images || [];
}
